import ZoomInPanIcon from './component.jsx'
export default ZoomInPanIcon
